import * as React from "react";
import { useCallback, useState } from "react";
import OverlayDropdown from "components/common/OverlayDropdown";
import useOverflowingComponents from "views/hooks/useOverflowingComponents";
import ActionDropdown from "./ActionDropdown";
const Action = ({ type, handlerArgs, menuContainer, element: Element, children }) => {
  const [open, setOpen] = useState(false);
  const { overflowingComponents, setOverflowingComponents, isFromContext } = useOverflowingComponents();
  const _onMenuClose = useCallback(() => setOpen(false), []);
  const _onMenuToggle = useCallback(() => setOpen(!open), [open]);
  const overflowingComponentsValues = Object.values(overflowingComponents);
  const element = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Element, { active: open }), /* @__PURE__ */ React.createElement("span", { className: "caret" }));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    OverlayDropdown,
    {
      show: open,
      toggleChild: element,
      placement: "right",
      onToggle: _onMenuToggle,
      onClose: _onMenuClose,
      menuContainer
    },
    /* @__PURE__ */ React.createElement(
      ActionDropdown,
      {
        handlerArgs,
        type,
        setOverflowingComponents,
        onMenuToggle: _onMenuToggle,
        overflowingComponents
      },
      children
    )
  ), !isFromContext && overflowingComponentsValues);
};
export default Action;
